/* wc-productsearch-seeder.v3.js — SAFE MINIMAL
   - Detect Shopify search params (?_pos,_psq,_ss,_v)
   - Flag arrival in sessionStorage (scoped to this handle)
   - Canonicalize URL to /collections/<collection>/products/<handle>
     (preserving ?model if present)
   - Broadcast 'wc:url-cleaned'
   - NO UI writes, NO placeholder forcing, NO hidden id clearing
*/
(function(){
  try{
    var url = new URL(location.href);
    var KEYS = ['_pos','_psq','_ss','_v'];
    if (!KEYS.some(function(k){ return url.searchParams.has(k); })) return;

    var root = document.getElementById('wc-product-root') || document.querySelector('[data-section-type="product"]');
    if (!root) return;

    var handle = root.getAttribute('data-prod-handle') ||
                 (location.pathname.match(/\/products\/([^\/?#]+)/)||[])[1] || '';
    var col = (root.getAttribute('data-collection-url') || '').replace(/\/$/,'');

    // remember that we came from search for this handle
    try { sessionStorage.setItem('wcSearchArrival', JSON.stringify({ h: handle, t: Date.now() })); } catch(_){}

    // build preferred URL and preserve ?model if present
    var base = handle ? (col ? (col + '/products/' + handle) : ('/products/' + handle)) : location.pathname;
    var model = url.searchParams.get('model');
    var dest = model ? (base + '?model=' + encodeURIComponent(model)) : base;

    if (dest !== (location.pathname + location.search)) {
      history.replaceState({}, '', dest);
    }
    document.documentElement.dispatchEvent(new CustomEvent('wc:url-cleaned', {bubbles:true}));
  }catch(_){}
})();
